import React, { useState, useEffect } from "react";
import numeral from "numeral";
import styles from "./BestyPricingCalculator.module.css";

const calculatePrice = (listings, option) => {
  if (listings === 0) return 0;

  let basePrice;
  if (listings <= 10) {
    basePrice = 3000 / 12;
  } else if (listings <= 50) {
    basePrice = 250 + (listings - 10) * 15;
  } else if (listings <= 100) {
    basePrice = 250 + 40 * 15 + (listings - 50) * 10;
  } else if (listings <= 250) {
    basePrice = 250 + 40 * 15 + 50 * 10 + (listings - 100) * 9;
  } else if (listings <= 499) {
    basePrice = 250 + 40 * 15 + 50 * 10 + 150 * 9 + (listings - 250) * 7;
  } else if (listings <= 999) {
    basePrice = 250 + 40 * 15 + 50 * 10 + 150 * 9 + 249 * 7 + (listings - 499) * 5;
  } else {
    basePrice = 250 + 40 * 15 + 50 * 10 + 150 * 9 + 249 * 7 + 500 * 5 + (listings - 999) * 3;
  }

  const price = Math.max(basePrice, (10000 / 12) * (listings >= 50 ? 1 : 0));

  if (option === "option2") {
    return price + listings * 3;
  }
  return price;
};

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

export const OPSCalculator = () => {
  const [listings, setListings] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [monthlyCost2, setMonthlyCost2] = useState(0);
  const [costPerListing2, setCostPerListing2] = useState(0);
  const [showQuarterly, setShowQuarterly] = useState(true);
  const [showAnnual, setShowAnnual] = useState(true);

  useEffect(() => {
    // Calculate Option 2 price and then apply 20% discount (make it 80% of Option 2)
    const option2Price = calculatePrice(listings, "option2");
    const opsPrice = option2Price * 0.8;
    const newMonthlyCost2 = opsPrice * (1 - discount / 100);

    setMonthlyCost2(newMonthlyCost2);
    setCostPerListing2(listings > 0 ? newMonthlyCost2 / listings : 0);
  }, [listings, discount]);

  return (
    <div className={styles.calculatorWrapper}>
      <h2 className={styles.calculatorTitle}>Besty OPS Pricing Calculator</h2>
      <div className={styles.inputSection}>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Listings</label>
          <input type="number" value={listings} onChange={(e) => setListings(Number(e.target.value) || 0)} className={styles.listingInput} placeholder="Enter Listing Count" />
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Discount %</label>
          <input type="number" value={discount} onChange={(e) => setDiscount(Number(e.target.value) || 0)} className={styles.discountInput} placeholder="Enter Discount (%)" />
        </div>
      </div>
      <div className={styles.toggleSection}>
        <label className={styles.toggleLabel}>
          <input type="checkbox" checked={showQuarterly} onChange={(e) => setShowQuarterly(e.target.checked)} className={styles.toggleCheckbox} />
          Show Quarterly Pricing
        </label>
        <label className={styles.toggleLabel}>
          <input type="checkbox" checked={showAnnual} onChange={(e) => setShowAnnual(e.target.checked)} className={styles.toggleCheckbox} />
          Show Annual Pricing
        </label>
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.pricingTable}>
          <thead>
            <tr>
              <th></th>
              <th>Pricing</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.rowLabel}>Cost per Listing (per month)</td>
              <td className={styles.copyableCell} onClick={() => copyToClipboard(numeral(costPerListing2).format("0.00"))} title="Click to copy">
                <span className={styles.priceValue}>${numeral(costPerListing2).format("0.00")}</span>
              </td>
            </tr>
            <tr>
              <td className={styles.rowLabel}>Monthly Price</td>
              <td className={styles.copyableCell} onClick={() => copyToClipboard(numeral(monthlyCost2).format("0,0.00"))} title="Click to copy">
                <span className={styles.priceValue}>${numeral(monthlyCost2).format("0,0.00")}</span>
              </td>
            </tr>
            {showQuarterly && (
              <tr>
                <td className={styles.rowLabel}>Quarterly Price</td>
                <td className={styles.copyableCell} onClick={() => copyToClipboard(numeral(monthlyCost2 * 0.95).format("0,0.00"))} title="Click to copy">
                  <span className={styles.priceValue}>${numeral(monthlyCost2 * 0.95).format("0,0.00")}</span>
                </td>
              </tr>
            )}
            {showAnnual && (
              <tr>
                <td className={styles.rowLabel}>Annual Price</td>
                <td className={styles.copyableCell} onClick={() => copyToClipboard(numeral(monthlyCost2 * 0.9).format("0,0.00"))} title="Click to copy">
                  <span className={styles.priceValue}>${numeral(monthlyCost2 * 0.9).format("0,0.00")}</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {(!showQuarterly || !showAnnual) && (
        <div className={styles.infoSection}>
          {!showQuarterly && (
            <div className={styles.infoText}>
              <strong>Save 5% if you pay quarterly:</strong> Quarterly monthly cost × 3 = quarterly payments
            </div>
          )}
          {!showAnnual && (
            <div className={styles.infoText}>
              <strong>Save 10% if you pay annually:</strong> Annual monthly cost × 12 = annual payments
            </div>
          )}
        </div>
      )}
    </div>
  );
};
